import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { Loader } from 'src/shared/components/loader';
import { ValidationError } from 'src/shared/components/validationError';
import { useGetClasses } from 'src/shared/hooks/useGetClasses';
import { Error } from './error';
import { Header } from './header';
import { SelectionList } from './list';
const MINIMUM_FOR_FLEXIBLE_SIZE = 5;
export function ClassList({ label, description, tooltip }) {
    const { formState: { errors }, setValue, watch } = useFormContext();
    const classesRequest = useGetClasses({ enabled: true });
    useEffect(function selectDefaultClass() {
        if (classesRequest.data && !watch('classes').length) {
            const defaultClassId = classesRequest.data.find((item) => item.defaultClass)?.hashId;
            defaultClassId && setValue('classes', [defaultClassId]);
        }
    }, [classesRequest.data, setValue, watch]);
    return (_jsxs("div", { className: "mb-5 lg:mb-6", children: [_jsx("label", { className: "mb-2 text-medium text-neutral-600", children: label }), _jsxs("div", { className: clsx('rounded-extralarge border-radius border-small', {
                    'border-neutral-200': !errors.classes?.message,
                    'border-danger-500': Boolean(errors.classes?.message)
                }), children: [_jsx(Header, { description: description, tooltip: tooltip }), _jsxs("div", { className: clsx('scrollbar overflow-y-scroll rounded-b-extralarge border-radius bg-neutral-100', { 'h-[260px]': (classesRequest.data?.length ?? 0) > MINIMUM_FOR_FLEXIBLE_SIZE }), children: [classesRequest.status === 'pending' && (_jsx(Loader, { full: "width", className: "py-10", "data-testid": "class-loader" })), classesRequest.status === 'error' && _jsx(Error, {}), classesRequest.status === 'success' && _jsx(SelectionList, { classes: classesRequest.data })] })] }), _jsx(ValidationError, { message: errors.classes?.message })] }));
}
